export const issueTableColumnsClass =
  "grid-cols-[84px_minmax(16rem,1fr)_132px_152px_168px] xl:grid-cols-[108px_minmax(20rem,1fr)_148px_184px_192px]";
